export default function PricingSection() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            料金プラン
          </h2>
        </div>

        {/* Pricing Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">

          {/* Plan 1: Monitor Price */}
          <div className="bg-gradient-to-br from-amber-400 to-amber-500 rounded-2xl p-8 border-4 border-amber-600 shadow-xl relative overflow-hidden">
            <div className="absolute top-4 right-4 bg-white text-amber-600 px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap shadow-md">
              🎉 期間限定
            </div>
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-white mb-2">
                モニター価格
              </h3>
              <p className="text-amber-100">制作＋運用（1〜12ヶ月）</p>
            </div>
            <div className="text-center mb-8">
              <div className="text-6xl font-bold text-white mb-2">¥3,980</div>
              <p className="text-amber-100 text-lg">月額</p>
            </div>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-white mr-3 mt-1"></i>
                <p className="text-white text-lg">HP制作・デザイン</p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-white mr-3 mt-1"></i>
                <p className="text-white text-lg">ホスティング費用込み</p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-white mr-3 mt-1"></i>
                <p className="text-white text-lg">修正・更新対応</p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-white mr-3 mt-1"></i>
                <p className="text-white text-lg">スマホ対応（レスポンシブ）</p>
              </div>
            </div>
          </div>

          {/* Plan 2: Regular Price */}
          <div className="bg-gradient-to-br from-cyan-600 to-cyan-700 rounded-2xl p-8 border-4 border-cyan-800 shadow-xl relative overflow-hidden">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-white mb-2">
                通常価格
              </h3>
              <p className="text-cyan-100">制作＋運用（1〜12ヶ月）</p>
            </div>
            <div className="text-center mb-8">
              <div className="text-6xl font-bold text-white mb-2">¥4,980</div>
              <p className="text-cyan-100 text-lg">月額</p>
            </div>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-amber-400 mr-3 mt-1"></i>
                <p className="text-white text-lg">HP制作・デザイン</p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-amber-400 mr-3 mt-1"></i>
                <p className="text-white text-lg">ホスティング費用込み</p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-amber-400 mr-3 mt-1"></i>
                <p className="text-white text-lg">修正・更新対応</p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-amber-400 mr-3 mt-1"></i>
                <p className="text-white text-lg">スマホ対応（レスポンシブ）</p>
              </div>
            </div>
          </div>

          {/* Plan 3: Operation Only */}
          <div className="bg-white rounded-2xl p-8 border-4 border-slate-300 shadow-xl">
            <div className="text-center mb-6">
              <h3 className="text-2xl font-bold text-slate-800 mb-2">
                運用プラン
              </h3>
              <p className="text-slate-600">13ヶ月〜</p>
            </div>
            <div className="text-center mb-8">
              <div className="text-6xl font-bold text-cyan-600 mb-2">¥2,980</div>
              <p className="text-slate-600 text-lg">月額</p>
            </div>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-cyan-600 mr-3 mt-1"></i>
                <p className="text-slate-700 text-lg">ホスティング継続</p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-cyan-600 mr-3 mt-1"></i>
                <p className="text-slate-700 text-lg">軽微な修正対応</p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-cyan-600 mr-3 mt-1"></i>
                <p className="text-slate-700 text-lg">12ヶ月でソースコード譲渡</p>
              </div>
              <div className="flex items-start">
                <i className="ri-check-line text-2xl text-cyan-600 mr-3 mt-1"></i>
                <p className="text-slate-700 text-lg">解約後も自分で運用可能</p>
              </div>
            </div>
          </div>

        </div>

        {/* Note */}
        <div className="text-center">
          <p className="text-slate-600 text-lg">
            ※ ドメイン取得代行：¥5,000/年（ドメイン実費は別途お客様負担）
          </p>
        </div>
      </div>
    </section>
  );
}
